import { useState } from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";

const WHATSAPP_LINK =
  "https://wa.me/5571999885711?text=" +
  encodeURIComponent(
    "Olá! Vi o lançamento do Curso de Games e gostaria de mais informações.",
  );

export function PopupDisplay() {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="p-0 gap-0 overflow-hidden border-none sm:max-w-[500 px] [&>button]:hidden">
        <div>
          <button
            type="button"
            onClick={() => setIsOpen(false)}
            aria-label="Fechar"
            className="absolute top-3 right-3 z-10 flex size-8 cursor-pointer items-center justify-center rounded-full bg-black/60 text-white transition-colors hover:bg-black/80 focus:outline-none focus:ring-2 focus:ring-white/70"
          >
            <X className="size-4" />
          </button>
        </div>

        <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">
          <img
            src="/lancamento_cursos_games.jpeg"
            alt="Lançamento do Curso de Games - ProCursos"
            className="w-full max-h-[70vh] object-contain"
          />
        </a>
      </DialogContent>
    </Dialog>
  );
}
